<template lang="html">
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    width="24px" height="24px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
        <path :fill="color" fill-rule="evenodd" clip-rule="evenodd" d="M12,1.999c-5.521,0-10,4.48-10,10C2,17.52,6.479,22,12,22
        c5.52,0,10-4.48,10-10.001C22,6.479,17.52,1.999,12,1.999z M7.032,8.274H5.79v8.694c0,0.683,0.559,1.242,1.242,1.242h8.694v-1.242
        H7.032V8.274z M16.968,5.79H9.517c-0.684,0-1.242,0.559-1.242,1.242v7.452c0,0.683,0.559,1.241,1.242,1.241h7.451
        c0.683,0,1.242-0.559,1.242-1.241V7.032C18.21,6.349,17.65,5.79,16.968,5.79z M16.347,11.379h-6.209v-1.242h6.209V11.379z
        M13.863,13.863h-3.726v-1.242h3.726V13.863z M16.347,8.896h-6.209V7.653h6.209V8.896z"/>
    </svg>
</template>

<script>
import { navIcon } from '@/functions/appColors';

export default {
    props: {
        color: {
            default: String(navIcon),
            type: String,
        },
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/icons/Watershed.vue